import { useState, useEffect } from "react";
import "./systemStatusWidget.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";

const SystemStatusWidget = () => {
  const [systemStatus, setSystemStatus] = useState("Loading...");
  const [isOperational, setIsOperational] = useState(false);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        // Use a timeout to ensure the fetch doesn't hang indefinitely
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('Request timeout')), 10000) // Increased to 10 seconds for better reliability
        );
        
        // Simple connectivity check - just see if the webpage is reachable
        // Using no-cors mode works in both development and production
        const response = await Promise.race([
          fetch('https://status.laddersuite.com/status/fres', { 
            mode: 'no-cors',
            method: 'HEAD' // HEAD request is lighter than GET
          }),
          timeoutPromise
        ]);
        
        // If fetch completes without error, the site is reachable
        setIsOperational(true);
        setSystemStatus("All Systems Operational");
        
      } catch (error) {
        console.error("Status check error:", error.message);
        
        // If we can't reach the status page, show degraded service
        setSystemStatus("Degraded Service");
        setIsOperational(false);
      }
    };

    // Check immediately and then every 5 minutes
    checkStatus();
    const interval = setInterval(checkStatus, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="systemStatusWidget">
      <div className="title">PSAPLink Status</div>
      <div className={`status ${isOperational ? "operational" : "degraded"}`}>
        {isOperational ? (
          <CheckCircleIcon className="icon" />
        ) : (
          <WarningIcon className="icon" />
        )}
        <span className="text">{systemStatus}</span>
      </div>
    </div>
  );
};

export default SystemStatusWidget;
